
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/glossary-of-climate-terms",
      function () {
        return require("private-next-pages/glossary-of-climate-terms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/glossary-of-climate-terms"])
      });
    }
  